import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { setIn } from 'immutable';
import { HistoryMaintenancePerformed } from './performed';
import '../../dialogs/maintenance-dialog.sass';
import { MaintenanceFields } from './fields';
import { validate_history_maintenance } from '../../utils/dialog-functions';
import { UniversalDialog } from 'console/dialogs/universal';
import { unpack_validation } from 'z3k-parser/validation/types';
import { MaintenanceAttachments } from 'console/tabs/maintenance/history/dialog/attachments';
import { MaintenanceDialogFooter } from 'console/tabs/maintenance/history/dialog/footer';
import { todayToUnix } from 'utils';
import { useCallbacks, usePartial } from 'console/shared/hooks/utils';
import { useConfirmDialog } from 'console/shared/hooks/ui';
import { ErrorBoundary } from 'console/shared/components/error-boundary';
const initial_device_maintenance = {
    id: '',
    name: '',
    materials: '',
    operations: '',
    price: '',
    performed: {
        date: todayToUnix(),
        mileage: null,
        moto_hours: null,
    },
    attachments: [],
};
export const HistoryMaintenanceDialog = memo(function HistoryMaintenanceDialogImpl(props) {
    const { open, onClose, onApply, onDeleteMaintenance, work_state, maintenance, device_id, } = props;
    const is_new = useMemo(() => maintenance == null, [maintenance]);
    const [temp_maintenance, setTempMaintenance] = useState(is_new ? initial_device_maintenance : maintenance);
    const [errors, setErrors] = useState(null);
    const onClickApply = useCallback(() => {
        const result = validate_history_maintenance(temp_maintenance);
        setErrors(result);
        if (result == null) {
            onApply({
                new_maintenance: setIn(temp_maintenance, ['performed'], {
                    ...temp_maintenance.performed,
                    is_got: true,
                }),
                created: is_new,
            });
            onClose();
        }
    }, [temp_maintenance, setErrors, is_new, onApply, onClose]);
    const onDelete = useCallbacks([
        usePartial(onDeleteMaintenance, temp_maintenance.id),
        onClose,
    ]);
    const onChangePerformed = useCallback((performed) => setTempMaintenance((maintenance) => ({ ...maintenance, performed })), []);
    const [ConfirmDialog, openConfirmDialog] = useConfirmDialog();
    return (_jsxs(_Fragment, { children: [_jsx(UniversalDialog, { open: open, onClose: onClose, maxWidth: "sm", title: is_new
                    ? 'Создание операции тех.обслуживания'
                    : 'Редактирование операции тех.обслуживания', scroll: "body", footer: _jsx(MaintenanceDialogFooter, { is_new: is_new, onDelete: openConfirmDialog, onClose: onClose, onClickApply: onClickApply }), children: _jsx(ErrorBoundary, { children: _jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [_jsx(MaintenanceFields, { value: temp_maintenance, onChange: setTempMaintenance, validation_result: errors, validation_warnings_result: null }), _jsx(HistoryMaintenancePerformed, { value: temp_maintenance.performed, work_state: work_state, onChange: onChangePerformed, validation_result: unpack_validation(errors, 'performed'), validation_warnings_result: null }), device_id && (_jsx(MaintenanceAttachments, { device_id: device_id, maintenance: temp_maintenance, onChangeMaintenance: setTempMaintenance }))] }) }) }), _jsx(ConfirmDialog, { onConfirm: onDelete, children: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C?" })] }));
});
